import { Vessel } from '@/models/Vessel'
import CachedResourceStore from '@/store/modules/CachedResourceStore'

export default new CachedResourceStore<Vessel>(Vessel, {
	namespaced: true
})
